import axios from "axios";
import axiosInstance from "@/services/https/global";
import CONFIG from "../config";

const revenueURL = `${CONFIG.BASE_URL}/payment-gateway/api/v1`;
const auditReportingURL = `${CONFIG.BASE_URL}/audit-reporting/api/v1`;

const toTransactionError = (error) => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    const base = typeof data === "object" && data !== null ? data : { message: data };
    const err = new Error(base.message ?? "Request failed");
    Object.assign(err, base, { statusCode: error.response?.status });
    return err;
  }
  return new Error("An unexpected error occurred");
};


export const getCustomerTransactions = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.status !== undefined) queryParams.status = params.status;
  if (params.userId !== undefined) queryParams.userId = params.userId;
  if (params.search && params.search.trim()) {
    queryParams.search = params.search.trim();
  }

  const response = await axiosInstance.get(`${revenueURL}/transaction/report`, {
    params: queryParams,
  });

  return response.data;
};

export const getTransactions = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.status !== undefined) queryParams.status = params.status;
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(
      `${revenueURL}/transaction/report`,
      {
        params: queryParams,
      },
    );
    return response.data;
  } catch (error) {
    throw toTransactionError(error);
  }
};

export const getTransactionStats = async () => {
  try {
    const response = await axiosInstance.get(`${revenueURL}/revenue/query`);
    return response.data;
  } catch (error) {
    throw toTransactionError(error);
  }
};

export const getCollections = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.status !== undefined) queryParams.status = params.status;
  if (params.channel !== undefined) queryParams.channel = params.channel;
  if (params.merchantId !== undefined) queryParams.merchantId = params.merchantId;
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(`${revenueURL}/stats/collections`, {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    throw toTransactionError(error);
  }
};

export const getPayouts = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.status !== undefined) queryParams.status = params.status;
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(`${auditReportingURL}/stats/payouts`, {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    throw toTransactionError(error);
  }
};

